import type { EventData } from '../../domain/message';
import { EventMessages } from '../../domain/message';
import { EMAIL_AGENT_SECTION } from '../../micro-apps/email-agent/tracking/emailAgentTracking';

import getTrackingLocation from './getTrackingLocation';
import { allTrackers } from './tracking';

const createTrackingMessageEventsService = () => {
  const handleTrackEvent = (
    category: string,
    action: string,
    subsection: string,
    url: string,
    custom_data?: Record<string, unknown>,
    section?: string
  ) => {
    allTrackers.dispatchTrackEvent(category, action, subsection, {
      location: getTrackingLocation(url),
      ...custom_data,
      ...(section ? { section } : {}),
    });
  };

  const handleTrackToggleEvent = (isOpen: boolean, category: string, subsection: string, url: string) => {
    handleTrackEvent(
      category,
      isOpen ? 'expand' : 'collapse',
      isOpen ? `open extension/${subsection}` : `close extension/${subsection}`,
      url
    );
  };

  const trackMessageEvent = (event: EventData) => {
    switch (event.message) {
      case EventMessages.DRAG_ICON:
        handleTrackEvent('floating icon', 'drag icon', 'floating icon location', event.url);
        break;
      case EventMessages.TOGGLE_VISIBILITY:
        if (event.fromBadge && event.isOpen) {
          handleTrackToggleEvent(true, 'floating icon', 'floating icon', event.url);
        } else if (event.fromToolbar) {
          handleTrackToggleEvent(event.isOpen, 'chrome bar', 'toolbar', event.url);
        } else if (event.fromGoogleCalendar) {
          handleTrackToggleEvent(event.isOpen, 'injected buttons', 'google calendar meeting', event.url);
        } else if (event.fromGmail) {
          handleTrackToggleEvent(event.isOpen, 'injected buttons', 'gmail', event.url);
        } else if (event.fromOutlook) {
          handleTrackToggleEvent(event.isOpen, 'injected buttons', 'outlook', event.url);
        }
        break;
      case EventMessages.TRACK_EVENT: {
        const isEmailAgent = !!(
          event.custom_data &&
          'target' in event.custom_data &&
          event.custom_data.target === 'email-agent'
        );
        const section = isEmailAgent ? EMAIL_AGENT_SECTION : undefined;
        const customDataWithoutTarget = event.custom_data ? { ...event.custom_data } : undefined;
        if (customDataWithoutTarget && 'target' in customDataWithoutTarget) {
          delete customDataWithoutTarget.target;
        }

        handleTrackEvent(
          event.category,
          event.action,
          event.eventName,
          event.url,
          customDataWithoutTarget as Record<string, unknown> | undefined,
          section
        );
        break;
      }
      default:
        break;
    }
  };

  return {
    trackMessageEvent,
  };
};

const TrackingMessageEventsService = createTrackingMessageEventsService();

export default TrackingMessageEventsService;
